import Vue from "vue";
import VueMasonry from "vue-masonry-css";
import VuePs from "./vue-ps";
import vClickOutside from "v-click-outside";
import RabbeyTable from "./RabbeyTable.vue";
import RabbeyTable2 from "./RabbeyTable2.vue";
import RabbeyTable3 from "./RabbeyTable3.vue";
import RabbeyTablesTabs from "./RabbeyTablesTabs.vue";
import RabbeyTablesTabs2 from "./RabbeyTablesTabs2.vue";
import RabbeyTopMenu from "./RabbeyTopMenu.vue";
import RabbeyToolbox from "./RabbeyToolbox.vue";
import RabbeyBaseDrawer from "./RabbeyBaseDrawer.vue";
import Peity from "vue-peity";

import { ResizeObserver } from "vue-resize";
import "vue-resize/dist/vue-resize.css";

Vue.component("resize-observer", ResizeObserver);
Vue.use(vClickOutside);
Vue.component("vue-scroll", VuePs);
Vue.use(VueMasonry);
Vue.component("rabbey-table", RabbeyTable);
Vue.component("rabbey-table2", RabbeyTable2);
Vue.component("rabbey-table3", RabbeyTable3);
Vue.component("rabbey-table-3", RabbeyTable3);
Vue.component("rabbey-tables-tabs", RabbeyTablesTabs);
Vue.component("rabbey-tables-tabs2", RabbeyTablesTabs2);
Vue.component("rabbey-top-menu", RabbeyTopMenu);
Vue.component("rabbey-toolbox", RabbeyToolbox);
Vue.component("rabbey-base-drawer", RabbeyBaseDrawer);
Vue.component("Peity", Peity);
